<template>
  <div class="news" v-loading="loading" element-loading-text="拼命加载中">
    <section class="first flex paddT20">
      <div class="first_left">
        <el-carousel height="450px" indicator-position="none" @change="carouselNew">
          <el-carousel-item v-for="(n, i) in bannerList" :key="i">
            <a href="javascript:void(0);" :title="n.title" @click="goRouter('/news/newDetail', n.id, 0)">
              <img :src="n.thumbnail" :alt="n.title" :title="n.title" class="image err_image" />
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <ul class="first_right">
        <li v-for="(n, i) in bannerList" :key="i" v-show="isShow == i">
          <div class="name">
            {{ n.title }}
          </div>
          <div class="text ">
            <div class="line_clamp5">
              {{ n.conAbstract }}
            </div>
          </div>
        </li>
      </ul>
    </section>
    <section class="ad" v-if="adList.length > 0">
      <ul>
        <li v-for="(n, i) in adList" :key="i" class="relative">
          <router-link :to="n.picUrl" target="_blank" :title="n.adName">
            <img :src="n.picSrc" alt="广告" :title="n.adName" class="ad_img" />
          </router-link>
          <span>广告</span>
        </li>
      </ul>
    </section>
    <section class="new_box">
      <ul class="list flex">
        <li class="box">
          <div class="title">
            <h2>新闻动态</h2>
            <i class="icon el-icon-d-arrow-right" title="更多" @click="goRouter('/news/new_list')"></i>
          </div>
          <ul>
            <li class="first flex">
              <div class="info" v-for="(n, i) in list.slice(0, 2)" :key="i">
                <a href="javascript:void(0);" @click="goRouter('/news/newDetail', n.id)">
                  <img :src="n.thumbnail || ''" :alt="n.title" :title="n.title" class="banner err_image" />
                  <a href="javascript:void(0);" :title="n.title" class="line_clamp1" @click="goRouter('/news/newDetail', n.id)">{{ n.title }}</a>
                </a>
              </div>
            </li>
            <li v-for="(n, i) in list.slice(2, 8)" :key="i" class="li line_clamp1">
              <a href="javascript:void(0);" :title="n.title" @click="goRouter('/news/newDetail', n.id)">
                <span v-show="n.author">「{{ n.author }}」</span>{{ n.title }}
              </a>
            </li>
          </ul>
        </li>
        <li class="box">
          <div class="title">
            <h2>政策法规</h2>
            <i class="icon icon el-icon-d-arrow-right" title="更多" @click="goRouter('/news/policy_list')"></i>
          </div>
          <ul>
            <li v-for="(n, i) in list1" :key="i" class="li line_clamp1">
              <a href="javascript:void(0);" :title="n.title" @click="goRouter('/news/newDetail', n.id, 1)">
                <span v-show="n.author">「{{ n.author }}」</span>{{ n.title }}
              </a>
            </li>
          </ul>
        </li>
        <li class="box">
          <div class="title">
            <h2>通知公告</h2>
            <i class="icon el-icon-d-arrow-right" title="更多" @click="goRouter('/news/msg_list')"></i>
          </div>
          <ul>
            <li v-for="(n, i) in list2" :key="i" class="li line_clamp1">
              <a href="javascript:void(0);" :title="n.title" @click="goRouter('/news/newDetail', n.id, 2)">
                <span v-show="n.author">「{{ n.author }}」</span>{{ n.title }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </section>
    <section class="in_style">
      <div class="title">
        <h1>残疾人风采</h1>
        <router-link to="people_list" target="_blank" class="more">看更多 <i class="el-icon-d-arrow-right" title="更多"></i></router-link>
      </div>
      <ul class="list">
        <li class="li" v-for="(n, i) in list3" :key="i">
          <a href="javascript:void(0);" :title="n.title" @click="goRouter('/news/newDetail', n.id, 3)">
            <img :src="n.thumbnail" alt="" class="banner err_avatar" />
            <h2 class="line_clamp2">{{ n.title }}</h2>
            <div class="text line_clamp4">
              {{ n.conAbstract }}
            </div>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
// import ad from "@/views/activity/jobFair-country/components/ad.vue";
export default {
  name: "index",
  components: {
    // ad,
  },
  metaInfo: {
    title: "新闻资讯-河南省残疾人就业创业网络服务平台",
    meta: [
      {
        name: "keywords",
        content: "残疾人就业,残疾人证,中国残疾人联合会,中国残联,",
      },
      {
        name: "description",
        content:
          "残疾人资讯平台为广大残疾人、残疾人工作者和更为广泛的关心、关注中国残疾人事业的群体提供全面、及时、准确的服务。",
      },
    ],
  },
  data() {
    return {
      isShow: "",
      bannerList: [],
      list: [],
      list1: [],
      list2: [],
      list3: [],
      adList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        consultationClassName: "",
        leve: "",
        city: "",
      },
      loading: false,
    };
  },
  methods: {
    info() {
      this.loading = true;
      // let locationText = localStorage.getItem("locationSelect");
      // this.locationSite = localStorage.getItem("locationSite");
      // if (this.locationSite === "河南省") {
      //   this.page.leve = "本省";
      //   this.page.city = locationText || "郑州市";
      // }
      this.swiper();
      this.news();
      this.policy();
      this.message();
      this.styles();
      this.getAdApi();
    },
    //轮播
    swiper() {
      this.$api
        .newsListApi({
          pageNum: 1,
          pageSize: 10,
          leve: this.page.leve,
          city: this.page.city,
          consultationClassId: "e30a083b8d0dfc47745f80e0d93da4ae",
        })
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.bannerList = res.data.data.records;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    //新闻
    news() {
      this.page.consultationClassId = "e30a083b8d0dfc47745f80e0d93da4ae";
      this.$api
        .newsListApi(this.page)
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.list = res.data.data.records;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //政策
    policy() {
      this.$api
        .newsListApi({
          pageNum: 1,
          pageSize: 10,
          leve: this.page.leve,
          city: this.page.city,
          consultationClassId: "26e159a4a2017aa425f605f7a974c119",
        })
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.list1 = res.data.data.records;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //通知
    message() {
      this.$api
        .newsListApi({
          pageNum: 1,
          pageSize: 10,
          leve: this.page.leve,
          city: this.page.city,
          consultationClassId: "865d7d4aba80e65911cb543d447375ad",
        })
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.list2 = res.data.data.records;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //残疾人风采
    styles() {
      this.page.pageSize = 6;
      this.$api
        .newsListApi({
          pageNum: 1,
          pageSize: 6,
          leve: this.page.leve,
          city: this.page.city,
          consultationClassId: "596c63766837057384c389ddc6e8be48",
        })
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.list3 = res.data.data.records;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //广告 40288113735703670173570367970000
    getAdApi() {
      this.$api
        .adApi({ classId: "40288113735703670173570367970000" })
        .then((res) => {
          this.adList = res.data.data;
        });
    },
    carouselNew(i) {
      this.isShow = i;
    },
    goRouter(url, id, i) {
      const { href } = this.$router.resolve({
        path: url,
        query: {
          id: id,
          active: i,
        },
      });
      window.open(href, "_blank");
      this.$api.updataReadApi({ id: id }).then((res) => {});
      console.log(url);
    },
  },
  created() {
    this.info();
    //判断是否移动端
    this.$mobile("https://m.cdpee.org.cn/#/pages/information/index");
  },
  mounted() {},
};
</script>

<style scoped lang="less">
@import "../../assets/css/news.less";
</style>
